import React from 'react';
import { parseDate } from 'utils/date';
import { splitSsn } from 'utils/strings';
import { usePortfolioTranslation as useLocale } from 'jsx/hooks/useTranslation';

export default function CIPStrengthRow({ item }) {
  const { t } = useLocale();
  const {
    eventDate,
    firmRegistryLink,
    cipCompanyScoreLink,
    subjectName,
    subjectRegno,
    newStrengthCategory,
    oldStrengthCategory,
  } = item;

  const business = process.env.REACT_APP_BUSINESS_WEB_URL;
  const firmUrl = `${business}/Search/Search.aspx?${firmRegistryLink}`;
  const cipUrl = `${business}/Reports/CipCompanyScore.aspx?${cipCompanyScoreLink}`;

  const checkCIPStrengthTitle =
    oldStrengthCategory === 'S1' && newStrengthCategory === 'S3'
      ? t('portfolioMonitoring_cipEvents_cipStrength_text_S1toS3')
      : oldStrengthCategory === 'S2' && newStrengthCategory === 'S3'
      ? t('portfolioMonitoring_cipEvents_cipStrength_text_S2toS3')
      : oldStrengthCategory === 'S3' && newStrengthCategory === 'S2'
      ? t('portfolioMonitoring_cipEvents_cipStrength_text_S3toS2')
      : oldStrengthCategory === 'S3' && newStrengthCategory === 'S1'
      ? t('portfolioMonitoring_cipEvents_cipStrength_text_S3toS1')
      : oldStrengthCategory === 'S2' && newStrengthCategory === 'S1'
      ? t('portfolioMonitoring_cipEvents_cipStrength_text_S2toS1')
      : oldStrengthCategory === 'S1' && newStrengthCategory === 'S2'
      ? t('portfolioMonitoring_cipEvents_cipStrength_text_S1toS2')
      : '';
  const checkCIPStrengthDesc =
    newStrengthCategory === 'S1'
      ? t('portfolioMonitoring_cipEvents_cipStrength_text_newStrengthCategory_S1')
      : newStrengthCategory === 'S2'
      ? t('portfolioMonitoring_cipEvents_cipStrength_text_newStrengthCategory_S2')
      : newStrengthCategory === 'S3'
      ? t('portfolioMonitoring_cipEvents_cipStrength_text_newStrengthCategory_S3')
      : '';
  return (
    <tr>
      <td>{parseDate(eventDate)}</td>
      <td>
        <div>
          <a href={firmUrl} target="_blank" rel="noopener noreferrer">
            {subjectName}
          </a>
        </div>
        <div>{splitSsn(subjectRegno)}</div>
      </td>
      <td>
        <div className="text-bold">{checkCIPStrengthTitle}</div>
        <div className="text-semibold">{checkCIPStrengthDesc}</div>
      </td>
      <td>
        <a target="_blank" href={cipUrl} rel="noopener noreferrer">
          {` ${t('portfolioMonitoring_cipEvents_view_cip')} `}
        </a>
      </td>
    </tr>
  );
}
